export var skeletonShapeStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      display: 'block',
      width: p.width,
      height: p.height,
      backgroundColor: v.shapeBackground,
      margin: v.shapeMargin
    }, p.round && {
      borderRadius: '50%'
    });
  }
};
//# sourceMappingURL=skeletonShapeStyles.js.map
